import React from 'react';
import { Check } from 'lucide-react';
import { RADIUS, TYPE, useTheme } from '../../theme';
import { baseButton } from './shared';

export interface StepItem { key: string; label: string }

/**
 * Stegindikator (DR1 §3.17 "Stepper"). Mobil: tunna staplar + "3 av 5".
 * Desktop (`vertical`): lista där klara steg har bock och går att klicka på.
 */
export function Stepper({ steps, current, done, onSelect, vertical }: {
  steps: readonly StepItem[]; current: number; done: (i: number) => boolean; onSelect?: (i: number) => void; vertical?: boolean;
}) {
  const T = useTheme();
  if (!vertical) {
    return (
      <div aria-label={`Steg ${current + 1} av ${steps.length}: ${steps[current]?.label}`} role="progressbar" aria-valuemin={1} aria-valuemax={steps.length} aria-valuenow={current + 1}
        style={{ display: 'flex', gap: 4 }}>
        {steps.map((s, i) => (
          <span key={s.key} style={{ flex: 1, height: 4, borderRadius: 2, background: i <= current ? T.accentFill : T.surface2 }} />
        ))}
      </div>
    );
  }
  return (
    <nav aria-label="Steg">
      <ol style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
        {steps.map((s, i) => {
          const active = i === current;
          const ok = done(i) && !active;
          return (
            <li key={s.key}>
              <button type="button" onClick={() => onSelect?.(i)} aria-current={active ? 'step' : undefined}
                style={{
                  ...baseButton, width: '100%', justifyContent: 'flex-start', gap: 10, minHeight: 44, padding: '0 10px', borderRadius: RADIUS.sm,
                  background: active ? T.accentSoft : 'transparent', color: active ? T.accentText : ok ? T.text : T.textMuted, ...TYPE.body, fontWeight: active ? 700 : 600,
                }}>
                <span aria-hidden style={{
                  width: 24, height: 24, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 12, fontWeight: 800,
                  background: ok ? T.ok : active ? T.accentFill : 'transparent', color: ok ? T.onOk : active ? T.onAccent : T.textMuted,
                  border: ok || active ? 'none' : `1.5px solid ${T.borderHover}`,
                }}>{ok ? <Check size={14} strokeWidth={3} /> : i + 1}</span>
                {s.label}
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
